import { render, staticRenderFns } from "./replacement.vue?vue&type=template&id=5b609dd8&scoped=true"
import script from "./replacement.vue?vue&type=script&lang=js"
export * from "./replacement.vue?vue&type=script&lang=js"
import style0 from "./replacement.vue?vue&type=style&index=0&id=5b609dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b609dd8",
  null
  
)

export default component.exports